<template>
    <div class="bg-white px-3 rounded-tl-3xl rounded-tr-3xl pt-3">
        <TabIndicator index="3" />
        <keep-alive>
            <components :is="module" />
        </keep-alive>
    </div>
</template>

<script>
import UserInfo from "./UsersInfo.vue"
import TabIndicator from "./module/TabIndicator.vue"
import Packages from "./Packages.vue"
import Payment from "./Payment.vue"
import Confirmation from "./Confirmation.vue"

export default {
    components: {
        UserInfo,
        TabIndicator,
        Packages,
        Payment,
        Confirmation
    },
    data() {
        return {
            // moduleId: 1
        }
    },
    computed: {
        moduleId() {
            // return 4
            return Number(this.$store.getters.getActiveTab);
        },
        module() {
            let activeModule = null
            switch (this.moduleId) {
                case 1:
                    activeModule = UserInfo;
                    break;
                case 2:
                    activeModule = Packages;
                    break;
                case 3:
                    activeModule = Payment;
                    break;
                case 4:
                    activeModule = Confirmation;
                    break;
                default:
                    activeModule = UserInfo;
                    break;
            }
            return activeModule
        }
    },
    beforeDestroy() {
        this.$store.dispatch("resetState");
    },
}
</script>

<style lang="scss" scoped></style>